import tempLogo from '../../static/images/temporary_logo.png';
import { Link, useNavigate } from 'react-router-dom';
import LanguageSelector from './LanguageSelector.jsx';
import { useTranslation } from 'react-i18next';

const DesktopBar = ({ isLogged, user, level }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="w-full xl:w-[1000px] flex">

            {/* Left */}
            <div className='flex-1 flex items-center justify-start gap-2 p-4'>

                {/* Logo */}
                <img src={tempLogo} alt="TicinoWild Logo" className='w-56 cursor-pointer' onClick={() => navigate("/")} />
            </div>

            {/* Right */}
            <div className='flex-1 flex items-center justify-end gap-2 p-4'>

                {/* Attività */}
                {
                    isLogged && level === 2 &&
                    <div className='flex gap-2'>
                        <Link to="/handle-activities">
                            <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                                <div className="pt-1"><i className="fi fi-rr-list-timeline text-2xl text text-[#225424]"></i></div>
                                <div className="hidden md:flex">{t('NavBar.manage')}</div>
                            </div></Link>
                    </div>
                }

                {/* Preferiti */}
                {
                    isLogged &&
                    <Link to="/favourites"><div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                        <div className="pt-1"><i className="fi fi-rs-heart text-2xl text text-[#225424]"></i></div>
                        <div>{t('NavBar.favourites')}</div>
                    </div></Link>
                }

                {/* Accedi registrati */}
                {
                    !isLogged &&
                    <div className="flex gap-4 items-center">
                        <Link to="/register-login?section=Login"><div className='bg-white py-2 px-3 rounded-xl'>{t('NavBar.signIn')}</div></Link>
                    </div>
                }
                {
                    isLogged &&
                    <Link to="/my-profile">
                        <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 md:px-4 gap-2">
                            <div className="pt-1"><i className="fi fi-rr-user text-2xl text text-[#225424]"></i></div>
                            <div className="hidden md:flex">{t('NavBar.profile')}</div>
                        </div>
                    </Link>
                }
                <LanguageSelector />
            </div>

        </div>
    )
}

export default DesktopBar;